<script>
    import { onMount, onDestroy } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Card from "../components/card.svelte";
    import ModalConfirm from "../components/modalconfirm.svelte";
    import Switch from "../components/switch.svelte";
    import router, { resolveExportUrl } from "../../router.js";
    import Nodatainfo from "../components/nodatainfo.svelte";
    import Spinner from "../components/spinner.svelte";
    import Message from "../components/message.svelte";
    import ProviderImage from "../import/components/image.svelte";
    import NoSetup from "../components/nosetup.svelte";
    import Button from "../components/button.svelte";
    import ConfigType from "./configType.svelte";

    export let mainConfig;
    export let providerId = 0;

    let optionsVM;
    let providerName = "";

    let titleProvider =
        providerId == 1 ? "Google" : providerId == 3 ? "Microsoft" : "";
    let showConfirmModal = false;
    let showReconnectModal = false;
    let isExportRunning = false;
    let isExportButtonRunning = false;
    let interval;
    let isPageloading = true;
    let hasConfigChanged = false;
    let exportStartTime = "";
    let StepURL = "";
    let image =
        providerId == 3
            ? "Microsoft_Sync_Icon.png"
            : providerId == 1
            ? "Google_Sync_Icon.png"
            : "";
    let exportEndTime;
    let currentTime;
    let disableExportNow = false;
    let months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    let showingPupilAliases = false;
    let showingStaffAliases = false;
    let userGuidePath =
        providerId == 1
            ? "https://nimbus.adept.education/user_guide/google-sync.html"
            : "https://nimbus.adept.education/user_guide/microsoft-sync.html";

    let switchState = false;

    let isTestExportButtonRunning = false;
    let isExportTestRunning = false;
    let exportTestStartTime = "";
    let exportTestEndTime = "";
    let isTestRun = false;

    let playPendingAnimation = false;
    let exportButtonLoadingText = "";
    let testExportButtonLoadingText = "";

    $: {
        disableExportNow = mainConfig.isPaused || isExportButtonRunning || isTestExportButtonRunning || playPendingAnimation;

    

        if (mainConfig.isPaused == true) {
            switchState = true;
            
        } else {
            switchState = false;
            
        }
    }

    onDestroy(() => {
        clearInterval(interval);
    });

    const RunRedirect = async () => {
        showReconnectModal = false;
        router.route(StepURL);
    };


    const RunExport = async () => {
        //isExportButtonRunning = true;
        await SetQueueExport();

        showConfirmModal = false;       
        await wrappedFetch(`/api/cloudConfig/ForceResyncSchool`, {
            method: "post",
        });
        await GetExportStatus();
        
        setCheckInterval();

        playPendingAnimation = true;
        
    };

    //function to set queue flag to 1
    const SetQueueExport = async () => {
        
        showConfirmModal = false;

        await wrappedFetch(
            `/api/cloudConfig/SetQueueExport?providerId=${providerId}`,
            { method: "post" }
        );

    };

    const OnClickExport = () => {
        showConfirmModal = true;
    };

    const SwitchPause = async () => {
        
        if (mainConfig.isPaused == true) {
            mainConfig.isPaused = false
        } else {
            mainConfig.isPaused = true;
        }
        
        await wrappedFetch(
            `/api/cloudConfig/PauseSync?providerId=${providerId}&isPaused=` +
                mainConfig.isPaused,
            { method: "post" }
        );
    };

    //check the status of the queue flag and play animation if its set to true
    const CheckQueueStatus = async () => {
        var resp = await wrappedFetch(
            `/api/cloudConfig/CheckQueueStatus?providerId=${providerId}`,
            { method: "post" }
        );

        var result = await resp.json();

        playPendingAnimation = result.isInQueue;

    }


    const GetExportStatus = async () => {
        var resp = await wrappedFetch(
            `/api/cloudConfig/CheckExportStatus?providerId=${providerId}`,
            { method: "post" }
        );

        var result = await resp.json();

        
        isExportRunning = result.isExportRunning;

        //piggybacking off this method in order to dynamically update pause button
        mainConfig.isPaused = result.isPaused;
        
        if (isExportRunning == true && isTestRun == false) {
            

            //if the export is running disable the pending animation and enable the running animation
            isExportButtonRunning = true;
            exportButtonLoadingText = "Running";
            playPendingAnimation = false;

        } else {
            isExportButtonRunning = false;
        }

        if (playPendingAnimation == true && isTestRun == false) {
            isExportButtonRunning = true;
            exportButtonLoadingText = "In queue";
        } 


        

        exportStartTime = result.exportStartTime;
        exportEndTime = Date.parse(result.exportEndTime);
    };


    const GetTestExportStatus = async () => {
        var resp = await wrappedFetch(
            `/api/TestExport/CheckTestExportStatus?providerId=${providerId}`,
            { method: "post" }
        );

        var result = await resp.json();

        
        isExportTestRunning = result.isExportRunning;
        isTestRun = result.isTestRun;

        if (isExportTestRunning == true && isTestRun == true) {
            isTestExportButtonRunning = true;
            textExportButtonLoadingText = "Running";
            isExportButtonRunning = false;
            playPendingAnimation = false;

        } else {
            isTestExportButtonRunning = false;
        }

        if (playPendingAnimation == true && isTestRun == true) {
            isTestExportButtonRunning = true;
            testExportButtonLoadingText = "In queue";
        }
        
        exportTestStartTime = result.exportStartTime;
        exportTestEndTime = Date.parse(result.exportEndTime);

    };

    const GetImportOptions = async () => {
        let resp = await wrappedFetch(`/api/import/GetAllOptions`, {
            method: "post",
        });
        let response = await resp.json();
        optionsVM = response.optionsVM;
        providerName = response.providerName
            ? response.providerName.toLowerCase()
            : "";
    };
    $:{
        if(mainConfig.accountConfig != null)
        {           
            if (mainConfig.accountConfig.staffEmailFormat == "UserId")
                mainConfig.accountConfig.staffEmailFormat = "USO";
            if (mainConfig.accountConfig.staffEmailFormat == "Username")
                mainConfig.accountConfig.staffEmailFormat = "USO.LEA";
            if (mainConfig.accountConfig.staffEmailFormat == "First.1Last")
                mainConfig.accountConfig.staffEmailFormat = "First.Initial";
            if (mainConfig.accountConfig.staffEmailFormat == "First1Last")
                mainConfig.accountConfig.staffEmailFormat = "FirstInitial";

            if (mainConfig.accountConfig.pupilEmailFormat == "UserId")
                mainConfig.accountConfig.pupilEmailFormat = "USO";
            if (mainConfig.accountConfig.pupilEmailFormat == "Username")
                mainConfig.accountConfig.pupilEmailFormat = "USO.LEA";
            if (mainConfig.accountConfig.pupilEmailFormat == "First.1Last")
                mainConfig.accountConfig.pupilEmailFormat = "First.Initial";
            if (mainConfig.accountConfig.pupilEmailFormat == "First1Last")
                mainConfig.accountConfig.pupilEmailFormat = "FirstInitial";

            if (mainConfig.accountConfig.pupilAliases != null && mainConfig.accountConfig.pupilAliases.length > 0) {
                mainConfig.accountConfig.pupilAliases.forEach((a) => {
                    if (a.format == "UserId") a.format = "USO";
                    if (a.format == "Username") a.format = "USO.LEA";
                    if (a.format == "First.1Last") a.format = "First.Initial";
                    if (a.format == "First1Last") a.format = "FirstInitial";
                });
            }
            if (mainConfig.accountConfig.staffAliases != null && mainConfig.accountConfig.staffAliases.length > 0) {
                mainConfig.accountConfig.staffAliases.forEach((a) => {
                    if (a.format == "UserId") a.format = "USO";
                    if (a.format == "Username") a.format = "USO.LEA";
                    if (a.format == "First.1Last") a.format = "First.Initial";
                    if (a.format == "First1Last") a.format = "FirstInitial";
                });
            }
        }

    }

    onMount(async () => {
       
        if (mainConfig.isConfigured) {
            await CheckQueueStatus();
            await GetTestExportStatus();
            setCheckTestInterval();
            
            await GetExportStatus();
            setCheckInterval();
            
        
        }      

        await GetImportOptions();
        currentTime = Date.parse(new Date());
        isPageloading = false;
    });

    const setCheckInterval = () => {
        interval = setInterval(() => {
            
            GetExportStatus();
            CheckQueueStatus();
            if (!isExportRunning) {
                //clearInterval(interval);
                HasConfigChanged();
                if (exportEndTime > currentTime) {
                    isExportButtonRunning = false;
                    currentTime = Date.parse(new Date());
                }
            }
        }, 4000);
    };

    const setCheckTestInterval = () => {
        interval = setInterval(() => {
            GetTestExportStatus();
            if (!isExportRunning) {
                //clearInterval(interval);
                HasConfigChanged();
                if (exportTestEndTime > currentTime) {
                    isTestExportButtonRunning = false;
                   
                    currentTime = Date.parse(new Date());
                }
            }
        }, 4000);
    };



    const HasConfigChanged = async () => {
        var resp = await wrappedFetch("/api/cloudConfig/HasConfigChanged");
        hasConfigChanged = await resp.json();
    };

    
</script>

<style>
    td:nth-child(odd) {
        width: 485px;
    }
    td:nth-child(even) {
        text-align: right;
    }
    tbody tr:first-child td {
        border-top: none;
    }
    th {
        font-size: 1rem;
        padding-bottom: 0;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .disabled {
        /* background-color: grey; */
        border: grey;
        pointer-events: none;
    }
</style>

<svelte:head>
    <title>{titleProvider} Configuration | Wavenet Nimbus</title>
</svelte:head>

{#if isPageloading}
    <Spinner />
{:else}
    {#if providerName == '' || (optionsVM && Object.entries(optionsVM).filter((k) => k[0] == 'importStudents' && k[1] == null).length > 0)}
        <Nodatainfo>
            <p>
                Your school has not yet configured the import of MIS data to
                Nimbus. Please visit the
                <a href="/app/import">Import Configuration page</a>
                first to set up the import.
            </p>
        </Nodatainfo>
        <br />
    {/if}
    {#if !mainConfig.isConfigured}
        <!-- <Card>
    <div slot="header"> <h3>Configuration</h3></div>
    <div slot="body">  
        <p style="color: red;"><b>{titleProvider} Sync is not currently configured.</b></p> 
        {#if providerId == 1}
            <p>By using Google Sync, you can easily keep your Google Workspace for Education accounts, classrooms and groups up-to-date.</p> 
        {:else}
            <p>By using Microsoft Sync, you can easily keep your Office 365 accounts and groups up-to-date.</p> 
        {/if}
        <p style="margin-bottom: 0px;">Please click the 'Setup' button below to get started.</p> 
    </div><div slot="footer">  <a class="btn btn-primary" href="/app/export/{providerId}/step1">Setup</a></div>
</Card> -->
        <!-- <NoSetup setupURL={`/app/export/${providerId}/step1`} {image}> -->
        <NoSetup {image}>
            <div slot="content">
                <p style="color: red;">
                    <b>{titleProvider} Sync is not currently configured.</b>
                </p>
                {#if providerId == 1}
                    <p>
                        By using Google Sync, you can easily keep your Google
                        Workspace for Education accounts, classrooms and groups
                        up-to-date.
                    </p>
                {:else if providerId == 3}
                    <p>
                        By using Microsoft Sync, you can easily keep your Office
                        365 accounts and groups up-to-date.
                    </p>
                {/if}
                <p style="">
                    Please click the “Setup” button below to configure the
                    export. If you get stuck at any point, please take a look at
                    our
                    <a href={userGuidePath} target="_blank">user guide</a>
                    or speak to our support team.
                </p>

                <ConfigType bind:providerId />
            </div>
        </NoSetup>
    {:else}
        <h1>Export Configuration</h1>
        <div>
            <!-- <Button
        buttonClass={"btn-primary"}
        bind:isLoading={isExportRunning}
        bind:disabled={mainConfig.isPaused}
        buttonText="Export Now"
        loadingText="Running"c
        on:click={OnClickExport}
    /> -->

            <!-- <div  style="float: right; margin-top: 7px;">
        <Switch bind:checked={mainConfig.isPaused} label="Pause" on:switch={SwitchPause} disabled={isExportRunning}
            icon="fa fa-pause"
            checkedModalHeader="Are you sure you want to pause the sync?"
            uncheckedModalHeader="Are you sure you want to resume the sync?"
            checkedModalMessage="Pausing the sync will cause users and other settings to not be managed automatically by Nimbus until the sync is resumed."
            uncheckedModalMessage="Resuming the sync will cause users and other settings to be managed automatically by Nimbus again."
        />
    </div> -->


            {#if playPendingAnimation && isTestRun == false}
            <br />
            <br />
            <Message
                message="Sync currently in queue for processing. Configurations can not be changed while sync is in the queue. " />

            {:else if playPendingAnimation && isTestRun}
            <br />
            <br />
            <Message
                message="Test Sync currently in queue for processing. Configurations can not be changed while sync is in the queue. " />


            {:else if isExportRunning && isTestExportButtonRunning == false}
                <br />
                <br />
                <Message
                    message="Sync currently in progress. Configurations can not be changed while sync is in progress. <br /> Current sync started at {exportStartTime} " />
                    
            {:else if isTestExportButtonRunning}
                <br />
                <br />
                <Message
                    message="Test Sync is currently in progress. Configurations can not be changed while sync is in progress. <br /> The current sync started at {exportTestStartTime} " />
            {:else if hasConfigChanged}
                <br />
                <br />
                <Message
                    message="The configuration has changed since the last sync ran. To update with the latest changes now, please click the Export Now button above. " />
            {/if}
        </div>

        <br />
        <div style="flex-flow:row wrap;display:flex;">
            <Card width="65%" marginRight="50px">
                <div slot="header" class="header">
                    <h3>
                        {#if providerId == 1}
                            Google
                        {:else if providerId == 3}Microsoft{/if}
                        Sync
                    </h3>
                    <div>
                        <a
                            class="btn btn-default {isExportRunning ? 'disabled' : ''}"
                            style="font-size:20px"
                            href="#"
                            on:click={() => {
                                showReconnectModal = true;
                                StepURL = resolveExportUrl(providerId, '/step1');
                            }}>
                            <i class="far fa-edit text-primary" />
                        </a>

                        <!-- <button class="btn btn-default" style="font-size:20px">
                <i class="far fa-question-circle text-primary" />
            </button> -->
                    </div>
                </div>
                <div slot="body">
                    <ProviderImage
                        provider={providerId == 1 ? 'google' : 'microsoft'} />
                </div>
            </Card>
            <Card width="30%">
                <div slot="header" class="header">
                    <h3>Status</h3>
                </div>
                <div slot="body">
                    <Button
                        buttonClass={'btn-primary'}
                        bind:isLoading={isExportButtonRunning}
                        bind:disabled={disableExportNow}
                        buttonText="Export Now"
                        loadingText={exportButtonLoadingText}
                        on:click={OnClickExport} />
                    <br />
                    <br />
                    <Button
                        buttonClass={'btn-primary'}
                        bind:isLoading = {isTestExportButtonRunning}
                        bind:isExportTest = {isTestExportButtonRunning}
                        buttonText="Test Export"
                        loadingText = {testExportButtonLoadingText}
                        on:click={() => {
                            StepURL = resolveExportUrl(providerId, '/testexport');
                            RunRedirect();
                        }} />
                    <br />
                    <br />
                    <div style="margin-left: 10px;">
                        <Switch
                            bind:checked={switchState}
                            label="Pause"
                            on:switch={SwitchPause}
                            disabled={isExportRunning || isTestExportButtonRunning || playPendingAnimation}
                            icon="fa fa-pause"
                            uncheckedModalHeader="Are you sure you want to pause the sync?"
                            checkedModalHeader="Are you sure you want to resume the sync?"
                            uncheckedModalMessage="Pausing the sync will cause users and other settings to not be managed automatically by Nimbus until the sync is resumed."
                            checkedModalMessage="Resuming the sync will cause users and other settings to be managed automatically by Nimbus again." />
                    </div>
                </div>
            </Card>
        </div>

        <br />
        <Card cardTable={true}>
            <div slot="header" class="header">
                <h3>Basic Configuration</h3>
                <div>
                    <a
                        class="btn btn-default {isExportRunning || playPendingAnimation ? 'disabled' : ''}"
                        style="font-size:20px"
                        href="#"
                        on:click={() => {
                            showReconnectModal = true;
                            StepURL = resolveExportUrl(providerId, '/step2');
                        }}>
                        <i class="far fa-edit text-primary" />
                    </a>
                    <!-- <button class="btn btn-default" style="font-size:20px">
                <i class="far fa-question-circle text-primary" />
            </button> -->
                </div>
            </div>
            <div slot="body">
                <table class="table" style="margin-bottom:15px;">
                    <thead>
                        <tr>
                            <th colspan="2">Pupils</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Create pupils?</td>
                            <td>
                                {#if mainConfig.accountConfig.syncPupils}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.accountConfig.syncPupils ? 'labeldisabled' : ''}>
                            <td>Which year groups do you want to create?</td>
                            <td>
                                {#if mainConfig.accountConfig.ignoredYears.length == 0}
                                    All
                                {:else}
                                    {#each mainConfig.selectedYears as year, i}
                                        {year.year}
                                        {#if i < mainConfig.selectedYears.length - 1}
                                            ,
                                        {/if}
                                    {/each}
                                {/if}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.accountConfig.syncPupils ? 'labeldisabled' : ''}>
                            <td>
                                Which domain do you want to use for pupils?
                            </td>
                            <td>
                                {mainConfig.accountConfig.pupilDomain || ''}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.accountConfig.syncPupils ? 'labeldisabled' : ''}>
                            <td>
                                Which naming convention do you want to use for
                                pupils?
                            </td>
                            <td>
                                {mainConfig.accountConfig.pupilEmailFormat || ''}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.accountConfig.syncPupils ? 'labeldisabled' : ''}>
                            <td>
                                What aliases do you want for pupils?
                                (optional)
                            </td>
                            <td>
                                {#if mainConfig.accountConfig.pupilAliases != null}

                                {#each mainConfig.accountConfig.pupilAliases as alias, i}
                                    <p
                                        style="margin-bottom: 0;  {i > 1 && showingPupilAliases == false ? 'display: none' : ''}">
                                        {alias.format}@{alias.domain}
                                    </p>
                                {/each}
                                {#if mainConfig.accountConfig.pupilAliases.length > 2}
                                    <button
                                        class="btn btn-default text-primary"
                                        style="font-size:12px"
                                        on:click={() => {
                                            showingPupilAliases = !showingPupilAliases;
                                        }}>
                                        <i
                                            class="text-primary {showingPupilAliases ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}" />
                                        {#if showingPupilAliases == false}
                                            See more
                                        {:else}See less{/if}
                                    </button>
                                {/if}

                                {/if}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table" style="margin-bottom:15px;">
                    <thead>
                        <tr>
                            <th colspan="2">Staff</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Create staff?</td>
                            <td>
                                {#if mainConfig.accountConfig.syncStaff}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.accountConfig.syncStaff ? 'labeldisabled' : ''}>
                            <td>Which domain do you want to use for staff?</td>
                            <td>
                                {mainConfig.accountConfig.staffDomain || ''}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.accountConfig.syncStaff ? 'labeldisabled' : ''}>
                            <td>
                                Which naming convention do you want to use for
                                staff?
                            </td>
                            <td>
                                {mainConfig.accountConfig.staffEmailFormat || ''}
                            </td>
                        </tr>                      
                            <tr
                                class={!mainConfig.accountConfig.syncStaff ? 'labeldisabled' : ''}>
                                <td>
                                    Replace first name with title for staff?
                                </td>
                                <td>
                                    {#if mainConfig.accountConfig.titleFirst}
                                        Yes
                                    {:else}No{/if}
                                </td>
                            </tr>
                        <tr
                            class={!mainConfig.accountConfig.syncStaff ? 'labeldisabled' : ''}>
                            <td>
                                What aliases do you want for staff? (optional)
                            </td>
                            <td>
                                {#if mainConfig.accountConfig.staffAliases != null}

                                {#each mainConfig.accountConfig.staffAliases as alias, i}
                                    <p
                                        style="margin-bottom: 0; {i > 1 && showingStaffAliases == false ? 'display: none' : ''}">
                                        {alias.format}@{alias.domain}
                                    </p>
                                {/each}
                                {#if mainConfig.accountConfig.staffAliases.length > 2}
                                    <button
                                        class="btn btn-default text-primary"
                                        style="font-size:12px"
                                        on:click={() => {
                                            showingStaffAliases = !showingStaffAliases;
                                        }}>
                                        <i
                                            class="text-primary {showingStaffAliases ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}" />
                                        {#if showingStaffAliases == false}
                                            See more
                                        {:else}See less{/if}
                                    </button>
                                {/if}
                                {/if}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table">
                    <thead>
                        <tr>
                            <th colspan="2">General</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Keep USO passwords in sync?</td>
                            <td>
                                {#if mainConfig.accountConfig.syncUSOPassword}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        {#if !mainConfig.accountConfig.syncUSOPassword}
                            <tr>
                                <td>
                                    Force new users to change password on first
                                    login?
                                </td>
                                <td>
                                    {#if mainConfig.accountConfig.forceChangePassword}
                                        Yes
                                    {:else}No{/if}
                                </td>
                            </tr>
                        {/if}
                        <tr>
                            <td>
                                Use legal or preferred names for account and
                                email creation?
                            </td>
                            <td>
                                {#if mainConfig.accountConfig.useLegal}
                                    Legal
                                {:else}Preferred{/if}
                            </td>
                        </tr>
                        {#if providerId == 1}
                            <tr>
                                <td>
                                    Which root organisational unit do you want
                                    to use to create and manage users?
                                </td>
                                <td>
                                    {mainConfig.accountConfig.rootOrgUnit || ''}
                                </td>
                            </tr>
                        {/if}
                        <tr>
                            <td>
                               Auto delete users?
                            </td>
                            <td>
                                {#if mainConfig.accountConfig.autoDeleteAccount == null}
                                    Not Set
                            {:else if mainConfig.accountConfig.autoDeleteAccount}{mainConfig.accountConfig.deletionDelayInDays} days
                            {:else}
                            No
                            {/if}
                            </td>
                        </tr>  
                        <tr>
                            <td>
                                Populate user accounts that have no email addresses?
                            </td>
                            <td>
                                {#if mainConfig.accountConfig.usoEmailAddressFormat == null}
                                    Not Set
                                    {:else if mainConfig.accountConfig.usoEmailAddressFormat == "none"}Do not populate
                            {:else if mainConfig.accountConfig.usoEmailAddressFormat == "google"}GoogleSync email format
                            {:else if mainConfig.accountConfig.usoEmailAddressFormat == "microsoft"}MicrosoftSync email format
                            {/if}
                            </td>
                        </tr>
                        <!-- {#if providerId == 3}
                <tr>
                    <td>
                        Use address book policies?
                    </td>
                    <td>
                        {#if mainConfig.accountConfig.supportABPs}Yes{:else}No{/if}
                    </td>
                </tr>
                {/if} -->
                    </tbody>
                </table>
            </div>
        </Card>

        <br />
        <Card cardTable={true}>
            <div slot="header" class="header">
                <h3>Groups</h3>
                <div>
                    <a
                        class="btn btn-default {isExportRunning || playPendingAnimation ? 'disabled' : ''}"
                        style="font-size:20px"
                        href="#"
                        on:click={() => {
                            showReconnectModal = true;
                            StepURL = resolveExportUrl(providerId, '/step3');
                        }}>
                        <i class="far fa-edit text-primary" />
                    </a>
                    <!-- <button class="btn btn-default" style="font-size:20px">
                <i class="far fa-question-circle text-primary" />
            </button> -->
                </div>
            </div>
            <div slot="body">
                <table class="table">
                    <tbody>
                        <tr>
                            <td>
                                Create and maintain
                                {#if providerId == 1}'basic'{/if}
                                {#if providerId == 1}Google{:else}Microsoft Security{/if}
                                Groups?
                            </td>
                            <td>
                                {#if mainConfig.groupsConfig.autoCreateGroups}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        {#if providerId == 1}
                            <tr
                                class={!mainConfig.groupsConfig.autoCreateGroups ? 'labeldisabled' : ''}>
                                <td>Create and maintain groups for classes?</td>
                                <td>
                                    {#if mainConfig.groupsConfig.supportAdvanceGroups}
                                        Yes
                                    {:else}No{/if}
                                </td>
                            </tr>
                            {#if mainConfig.groupsConfig.supportAdvanceGroups}
                                <tr
                                    class={!mainConfig.groupsConfig.autoCreateGroups ? 'labeldisabled' : ''}>
                                    <td>
                                        What type of class data would you like
                                        to use for these groups?
                                    </td>
                                    <td>
                                        {#if mainConfig.groupsConfig.supportRegGroups}
                                            Registration
                                        {/if}
                                        {#if mainConfig.groupsConfig.supportRegGroups && mainConfig.groupsConfig.supportSubjGroups}
                                            &
                                        {/if}
                                        {#if mainConfig.groupsConfig.supportSubjGroups}
                                            Subject
                                        {/if}
                                        Classes
                                    </td>
                                </tr>
                            {/if}
                        {/if}
                        {#if providerId == 3}
                            <tr
                                class={!mainConfig.groupsConfig.autoCreateGroups ? 'labeldisabled' : ''}>
                                <td>
                                    Create and maintain Microsoft O365 Groups?
                                </td>
                                <td>
                                    {#if mainConfig.groupsConfig.createO365Groups}
                                        Yes
                                    {:else}No{/if}
                                </td>
                            </tr>
                        {/if}
                        <tr
                            class={!mainConfig.groupsConfig.autoCreateGroups ? 'labeldisabled' : ''}>
                            <td>Add a prefix to the group names?</td>
                            <td>
                                {#if mainConfig.groupsConfig.prependGroupsWithDfE}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        {#if mainConfig.groupsConfig.prependGroupsWithDfE}
                            <tr
                                class={!mainConfig.groupsConfig.autoCreateGroups ? 'labeldisabled' : ''}>
                                <td>What prefix do you want to use?</td>
                                <td>
                                    {#if mainConfig.groupsConfig.useDfe}
                                        {mainConfig.groupsConfig.dfEId}
                                    {:else}
                                        {mainConfig.groupsConfig.prependCode}
                                    {/if}
                                </td>
                            </tr>
                        {/if}
                    </tbody>
                </table>
            </div>
        </Card>

        <br />

        <Card cardTable={true}>
            <div slot="header" class="header">
                <h3>
                    {#if providerId == 1}Classrooms{:else}Teams{/if}
                </h3>
                <div>
                    <a
                        class="btn btn-default {isExportRunning || playPendingAnimation ? 'disabled' : ''}"
                        style="font-size:20px"
                        href="#"
                        on:click={() => {
                            showReconnectModal = true;
                            StepURL = resolveExportUrl(providerId, '/step4');
                        }}>
                        <i class="far fa-edit text-primary" />
                    </a>
                </div>
            </div>
            <div slot="body">
                <table class="table">
                    <tbody>
                        <tr>
                            <td>
                                Create and maintain
                                {#if providerId == 1}
                                    Google Classrooms
                                {:else}Microsoft Teams{/if}?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.autoCreateClasses}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        <!-- {#if mainConfig.classesConfig.autoCreateClasses} -->
                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                Which type of class data do you want to use?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.createSubjectClasses == null}
                                    -
                                {:else if mainConfig.classesConfig.createSubjectClasses}
                                    Subject
                                {:else}Registration{/if}
                            </td>
                        </tr>
                        <!-- {/if} -->
                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                Create
                                {#if providerId == 1}classrooms{:else}teams{/if}
                                where there is no teacher data?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.hasDefaultTeacher}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        
                        {#if mainConfig.classesConfig.hasDefaultTeacher && mainConfig.classesConfig.teacherPID != null}
                            <tr
                                class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                                <td>Who do you want to add?</td>
                                <td>{mainConfig.classesConfig.teacherName}</td>
                            </tr>
                        {/if}
                        
                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                Add a prefix to the
                                {#if providerId == 1}classroom{:else}team{/if}
                                names?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.prependClassesWithDfE}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>

                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                Automatically delete teachers from
                                {#if providerId == 1}
                                    Google Classrooms
                                {:else}Microsoft Teams{/if}?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.deleteTeachersFromClass}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                Automatically delete pupils from
                                {#if providerId == 1}
                                    Google Classrooms
                                {:else}Microsoft Teams{/if}?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.deletePupilsFromClass}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        {#if providerId == 3}
                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                Automatically assign Teams policy to staff?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.assignTeamsPolicyToStaff}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                Automatically assign Teams policy to pupils?
                            </td>
                            <td>
                                {#if mainConfig.classesConfig.assignTeamsPolicyToStudents}
                                    Yes
                                {:else}No{/if}
                            </td>
                        </tr>
                        {/if}
                    </tbody>
                </table>
            </div>
        </Card>

        <br />
        <Card cardTable={true}>
            <div slot="header" class="header">
                <h3>
                    {#if providerId == 1}Classrooms{:else}Teams{/if}
                    Archival
                </h3>
                <div>
                    <a
                        class="btn btn-default {isExportRunning || playPendingAnimation ? 'disabled' : ''}"
                        style="font-size:20px"
                        href="#"
                        on:click={() => {
                            showReconnectModal = true;
                            StepURL = resolveExportUrl(providerId, '/step5');
                        }}>
                        <i class="far fa-edit text-primary" />
                    </a>
                </div>
            </div>
            <div slot="body">
                <table class="table">
                    <tbody>
                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                How do you want to archive
                                {#if providerId == 1}
                                    Google Classrooms
                                {:else}Microsoft Teams{/if}
                                at the end of school year?
                            </td>
                            <td>
                                {#if mainConfig.archivalConfig.isAutoArchived == null}
                                    -
                                {:else if mainConfig.archivalConfig.isAutoArchived}
                                    Automatically
                                {:else}Manually{/if}
                            </td>
                        </tr>

                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                When do you want to automatically archive
                                {#if providerId == 1}
                                    classrooms
                                {:else}teams{/if}?
                            </td>
                            <td>
                                {mainConfig.archivalConfig.archiveDay == null ? '-' : mainConfig.archivalConfig.archiveDay}
                                {mainConfig.archivalConfig.archiveMonth == null ? '' : months[mainConfig.archivalConfig.archiveMonth]}
                            </td>
                        </tr>

                        <tr
                            class={!mainConfig.classesConfig.autoCreateClasses ? 'labeldisabled' : ''}>
                            <td>
                                When do you want to automatically resume syncing
                                {#if providerId == 1}
                                    classrooms
                                {:else}teams{/if}?
                            </td>
                            <td>
                                {mainConfig.archivalConfig.resumeDay == null ? '-' : mainConfig.archivalConfig.resumeDay}
                                {mainConfig.archivalConfig.resumeMonth == null ? '' : months[mainConfig.archivalConfig.resumeMonth]}
                            </td>
                        </tr>
                        <!-- {:else}
                        <tr>
                            <td>
                                {#if providerId == 1} Google Classrooms {:else} Microsoft Teams {/if} are not being synced.
                            </td>
                        </tr>
                        {/if} -->
                    </tbody>
                </table>
            </div>
        </Card>

        <br />

        {#if providerId == 3}
            <Card cardTable={true}>
                <div slot="header" class="header">
                    <h3>Licenses</h3>
                    <div>
                        <a
                            class="btn btn-default {isExportRunning || playPendingAnimation ? 'disabled' : ''}"
                            style="font-size:20px"
                            href="#"
                            on:click={() => {
                                showReconnectModal = true;
                                StepURL = resolveExportUrl(providerId, '/step6');
                            }}>
                            <i class="far fa-edit text-primary" />
                        </a>
                    </div>
                </div>
                <div slot="body">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td>
                                    Which license do you want to assign to new
                                    pupil accounts?
                                </td>
                                <td>
                                    {mainConfig.licensesConfig.studentsSKUName == null ? '-' : mainConfig.licensesConfig.studentsSKUName}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Which license do you want to assign to new
                                    staff accounts?
                                </td>
                                <td>
                                    {mainConfig.licensesConfig.staffSKUName == null ? '-' : mainConfig.licensesConfig.staffSKUName}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Card>
        {/if}
    {/if}
{/if}

<ModalConfirm
    bind:showModal={showConfirmModal}
    zindex="1052"
    sizeClass="modal-md"
    targetClass="confirm-options"
    showCancel={true}
    on:confirm={RunExport}>
    <div slot="header">
        <h4 class="title">Are you sure you want to run an export?</h4>
    </div>
    <div slot="content">
        Changes are typically made within a few minutes automatically. However,
        you can choose to force an export immediately. This will resync all
        users with your school’s configuration. This may be useful if an
        expected change has not yet been made on your platform or if you’ve been
        advised to do this by support.
    </div>
</ModalConfirm>

<ModalConfirm
    bind:showModal={showReconnectModal}
    zindex="1052"
    sizeClass="modal-lg"
    targetClass="confirm-options"
    buttonClass="btn-primary"
    showCancel={true}
    on:confirm={RunRedirect}>
    <div slot="header">
        <h4 class="title">Are you sure you want to edit the configuration?</h4>
    </div>
    <div slot="content">
        <p>
            By changing the configuration it may have undesired consequences on
            your
            {#if providerId == 1}Google{:else}Microsoft{/if}
            environment. If you are unsure as to what the result of a change may
            be, please consult our help documentation or reach out to support.
        </p>
        <p>
            Please note that if you proceed, and some time has passed since the
            configuration was set up, you may be asked to log in again with your
            {#if providerId == 1}Google{:else}Microsoft{/if}
            admin account.
        </p>
    </div>
</ModalConfirm>
